var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.artists)?_c('BaseSection',{attrs:{"padded":""}},[_c('ArtistBlock',{attrs:{"artists":_vm.artists}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }